import type { RovoConfigurationProviderProps } from '@jira/ai-rovo_actions-shared-types/src/RovoConfigurationProviderProps.types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const permissionsConfigProviderEntrypoint: EntryPoint<
	EntryPointComponent<{}, {}, RovoConfigurationProviderProps, {} | null>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "ai-rovo-actions-admin-permissions-provider" */ './PermissionsConfigProvider'
		).then((module) => module.PermissionsConfigProviderEntry),
	),
	getPreloadProps: () => ({}),
});
